/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelSocialFacebook64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelSocialFacebook64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M24.4844 22.5H39.5156C40.5725 22.5003 41.4997 23.4275 41.5 24.4844V39.5156C41.4997 40.5804 40.6251 41.4997 39.5156 41.5H36.3789V35.3486H38.8633V31.1973H36.3789V30.0605C36.3789 29.9756 36.3847 29.917 36.3936 29.8779C36.3965 29.8651 36.3991 29.8558 36.4014 29.8496C36.4195 29.8435 36.4635 29.833 36.5459 29.833H38.8633V25.3184H36.1211C33.5505 25.3184 31.7422 27.476 31.7422 30.1211V31.1973H29.3184V35.3486H31.7422V41.5H24.4844C23.4275 41.4997 22.5003 40.5725 22.5 39.5156V24.4844C22.5003 23.4275 23.4275 22.5003 24.4844 22.5Z"
            fill="currentColor"
            stroke="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelSocialFacebook64Icon.tags = ['facebook', 'fb', 'meta'];

AddPanelSocialFacebook64Icon.category = '64x64 (Add panel)';

AddPanelSocialFacebook64Icon.iconSize = 64;
